import {createTable,from,Filter,dateChange} from '@/api/jsDb/dbms.js'
import {parseTime} from '@/utils/ruoyi.js';


//定义表结构区====================================================
var tb_data_collection = {
    paperId:"",//收集表编号
    title:"",//标题
    note:"",//收集说明
    startTime:"",//开始时间
    endTime:"",//失效时间
    state:"",//状态
    createBy:"",//创建人
    createTime:"",//创建时间
    isDataRepeat:"",//一次性填完，每日填完
    filledNum:"",//已收集数
    itemList:"",//[0|茅台酒>到货数量|1],[0|茅台酒>到货数量|1]
}

var tb_data_collection_items = {
    itemId:"",//项目id
    paperId:"",//问卷id
    groupTitle:"",//分组标题
    itemTitle:"",//项目标题
    itemOrder:"",//排列序号
    itemStore:"",//存储的字段名
    preRequired:"",//先填字段
    itemShow:"",//列表卡显示配置
}

// var tb_data_collection_items = {
//     itemId:"",//项目id
//     paperId:"",//问卷id
//     parentItemId:"",//父id
//     sortNo:"",//排序号
//     title:"",//标题
//     remark:"",//说明
//     type:"",//标题，子标题，选项
//     score:"",//分数
//     answerType:"",//填空，单选，多选，填写
//     answer:"",//答案
//     maxLength:"",//最大输入长度
//     valueType:"",//字符、数字、日期
//     preRequired:"",//先填项
//     required:"",//必填
    
// }

var tb_data_collection_record = {
    recordId:"",
    paperId:"",
    collectionTitle:"",
    fillBy:"",
    createTime:"",
    item0:"",
    item1:"",
    item2:"",
    item3:"",
    item4:"",
    item5:"",
    item6:"",
    item7:"",
    item8:"",
    item9:"",
    item10:"",
    item11:"",
    item12:"",
    item13:"",
    item14:"",
    item15:"",
}


//创建表区和导出区=============================================================
var db = {
     from:from, //必须导出from方法
    // parseTime:parseTime,
    // dateChange:dateChange,
    // Activity:Activity,
    tb_data_collection: createTable(tb_data_collection,"Q",20201000),
    tb_data_collection_items: createTable(tb_data_collection_items,"C",20201000),
    tb_data_collection_record: createTable(tb_data_collection_record,"D",20201000),
    // tb_dept:createTable(tb_dept),
}
export default db;



//数据初始区=============================================================
//db.xxxx.where().where().where().select()   selected
//db.xxxx.new().set().set().set().insert()   inserted;
//db.xxxx.find().set().set().set().update()  upadated;
//db.xxxx.find().delete();  deleted
function fill_tb_dictionary(){
    let dic;
    //鉴定结果
    dic = [
        {label:"==全部==",value:"0"},
        {label:"鉴定为真",value:"1"},
        {label:"鉴定为假",value:"2"},
      ]
    // add_dic_item(dic,"dic_verifyResult","先行兑换状态");
}

//选项填充字典
function add_dic_item(dic,dicId,dicName){
    for(let i=0;i<dic.length;i++){
        db.from(db.tb_dictionary).new()
        .set("dicId", dicId)
        .set("dicName", dicName)
        .set("label", dic[i].label)
        .set("value", dic[i].value)
        .insert()
    }
}
fill_tb_dictionary();

// itemId:"",//收集表编号
// title:"",//标题
// note:"",//收集说明
// startTime:"",//开始时间
// endTime:"",//失效时间
// state:"",//状态
// createBy:"",//创建人
// createTime:"",//创建时间
// filledNum:"",//已收集数
//填充部门初始值
db.from(db.tb_data_collection).new()
//问卷1
.set("paperId","Q01")
.set("title","双节期间进销存统计表")
.set("note","注：本表请于每周二、五中午12:00之前通过EM/OA发送至市场管理部陈田甜处汇总提报。")
.set("startTime","2021-01-08")
.set("endTime","2021-03-08")
.set("state","已发布")
.set("createBy","盛典林")
.set("createTime","2021-01-08")
.set("filledNum",0)
.insert().new()
//问卷2
.set("paperId","Q02")
.set("title","双节期间茅台酒价格信息采集表")
.set("note","注：本表请于每周二、五中午12:00之前通过EM/OA发送至市场管理部陈田甜处汇总提报。")
.set("startTime","2021-01-08")
.set("endTime","2021-03-08")
.set("state","已发布")
.set("createBy","盛典林")
.set("createTime","2021-01-08")
.set("filledNum",0)
.insert().new()
//问卷3
.set("paperId","Q03")
.set("title","双节期间省区驻场服务及重点监管信息汇总表")
.set("note","注：本表请于每周二、五中午12:00之前通过EM/OA发送至市场管理部陈田甜处汇总提报。")
.set("startTime","2021-01-08")
.set("endTime","2021-03-08")
.set("state","已发布")
.set("createBy","盛典林")
.set("createTime","2021-01-08")
.set("filledNum",0)
.insert().new()
//问卷4
.set("paperId","Q04")
.set("title","特约经销商元旦春节“设店”销售情况统计表")
.set("note","注：本表请于每周二、五中午12:00之前通过EM/OA发送至市场管理部陈田甜处汇总提报。")
.set("startTime","2021-01-08")
.set("endTime","2021-03-08")
.set("state","已发布")
.set("createBy","盛典林")
.set("createTime","2021-01-08")
.set("filledNum",0)
.insert().new()



//填充问卷1 Q01
db.from(db.tb_data_collection_items).new()
//标题
.set("itemId","I01")//项目id
.set("paperId","Q01")//问卷id
.set("groupTitle","基本信息")//分组标题
.set("itemTitle","填报标题")//项目标题
.set("itemOrder",1)//排列序号
.set("itemStore","collectionTitle")//存储的字段名
.set("preRequired",1)//先填字段
.set("itemShow",1)//列表卡显示配置
.insert().new()
//条目1
.set("itemId","I01")//项目id
.set("paperId","Q01")//问卷id
.set("groupTitle","基本信息")//分组标题
.set("itemTitle","所属省区")//项目标题
.set("itemOrder",1)//排列序号
.set("itemStore","item0")//存储的字段名
.set("preRequired",1)//先填字段
.set("itemShow",0)//列表卡显示配置
.insert().new()
//条目2
.set("itemId","I02")//项目id
.set("paperId","Q01")//问卷id
.set("groupTitle","基本信息")//分组标题
.set("itemTitle","统计人")//项目标题
.set("itemOrder",2)//排列序号
.set("itemStore","item1")//存储的字段名
.set("preRequired",1)//先填字段
.set("itemShow",0)//列表卡显示配置
.insert().new()
//条目3
.set("itemId","I03")//项目id
.set("paperId","Q01")//问卷id
.set("groupTitle","基本信息")//分组标题
.set("itemTitle","单位名称")//项目标题
.set("itemOrder",3)//排列序号
.set("itemStore","item2")//存储的字段名
.set("preRequired",1)//先填字段
.set("itemShow",1)//列表卡显示配置
.insert().new()
//条目4
.set("itemId","I10")//项目id
.set("paperId","Q01")//问卷id
.set("groupTitle","普通茅台酒")//分组标题
.set("itemTitle","上次结余库存")//项目标题
.set("itemOrder",4)//排列序号
.set("itemStore","item3")//存储的字段名
.set("preRequired",0)//先填字段
.set("itemShow",0)//列表卡显示配置
.insert().new()
//条目5
.set("itemId","I11")//项目id
.set("paperId","Q01")//问卷id
.set("groupTitle","普通茅台酒")//分组标题
.set("itemTitle","统计期内到货")//项目标题
.set("itemOrder",5)//排列序号
.set("itemStore","item4")//存储的字段名
.set("preRequired",0)//先填字段
.set("itemShow",0)//列表卡显示配置
.insert().new()
//条目6
.set("itemId","I12")//项目id
.set("paperId","Q01")//问卷id
.set("groupTitle","普通茅台酒")//分组标题
.set("itemTitle","统计期内销售-整箱")//项目标题
.set("itemOrder",6)//排列序号
.set("itemStore","item5")//存储的字段名
.set("preRequired",0)//先填字段
.set("itemShow",0)//列表卡显示配置
.insert().new()
//条目7
.set("itemId","I13")//项目id
.set("paperId","Q01")//问卷id
.set("groupTitle","普通茅台酒")//分组标题
.set("itemTitle","统计期内销售-散瓶")//项目标题
.set("itemOrder",7)//排列序号
.set("itemStore","item6")//存储的字段名
.set("preRequired",0)//先填字段
.set("itemShow",0)//列表卡显示配置
.insert().new()
//条目8
.set("itemId","I14")//项目id
.set("paperId","Q01")//问卷id
.set("groupTitle","普通茅台酒")//分组标题
.set("itemTitle","统计期内结存")//项目标题
.set("itemOrder",8)//排列序号
.set("itemStore","item7")//存储的字段名
.set("preRequired",0)//先填字段
.set("itemShow",0)//列表卡显示配置
.insert().new()
//条目9
.set("itemId","I15")//项目id
.set("paperId","Q01")//问卷id
.set("groupTitle","精品茅台酒")//分组标题
.set("itemTitle","上次结余库存")//项目标题
.set("itemOrder",9)//排列序号
.set("itemStore","item8")//存储的字段名
.set("preRequired",0)//先填字段
.set("itemShow",0)//列表卡显示配置
.insert().new()
//条目10
.set("itemId","I16")//项目id
.set("paperId","Q01")//问卷id
.set("groupTitle","精品茅台酒")//分组标题
.set("itemTitle","统计期内到货")//项目标题
.set("itemOrder",10)//排列序号
.set("itemStore","item9")//存储的字段名
.set("preRequired",0)//先填字段
.set("itemShow",0)//列表卡显示配置
.insert().new()
//条目11
.set("itemId","I17")//项目id
.set("paperId","Q01")//问卷id
.set("groupTitle","精品茅台酒")//分组标题
.set("itemTitle","统计期内销售-整箱")//项目标题
.set("itemOrder",11)//排列序号
.set("itemStore","item10")//存储的字段名
.set("preRequired",0)//先填字段
.set("itemShow",0)//列表卡显示配置
.insert().new()
//条目12
// .set("itemId","I18")//项目id
// .set("paperId","Q01")//问卷id
// .set("groupTitle","精品茅台酒")//分组标题
// .set("itemTitle","统计期内销售-散瓶")//项目标题
// .set("itemOrder",12)//排列序号
// .set("itemStore","item11")//存储的字段名
// .set("preRequired",0)//先填字段
// .set("itemShow",0)//列表卡显示配置
// .insert().new()
//条目13
.set("itemId","I19")//项目id
.set("paperId","Q01")//问卷id
.set("groupTitle","精品茅台酒")//分组标题
.set("itemTitle","统计期内结存")//项目标题
.set("itemOrder",13)//排列序号
.set("itemStore","item12")//存储的字段名
.set("preRequired",0)//先填字段
.set("itemShow",0)//列表卡显示配置
.insert().new()


















// for(let i=0;i<200;i++){
//     db.from(db.tb_user).new()
//         .set("userCode", 1000+i)
//         .set("userName", "曾娟娟" +i)
//         .set("userDept", "综合管理部"+i)
//         .set("userDeptCode", 2000+i)
//         .insert(); 
// }




// WEBPACK FOOTER //
// ./src/api/jsDb/db.js